<tvb-badge
  [label]="getSaleBadgeText()"
  backgroundColor="#EDE9E1"
  color="#000000"
  borderRadius="0px"
  style="white-space: nowrap"
  *ngIf="showSaleBadge && product?.isDiscount == 1 && +product?.discount?.toFixed(0) > 3"
></tvb-badge>

<app-wishlist-icon [hit]="product" [productId]="product?.id" [prdImg]="product?.imageUrl"></app-wishlist-icon>

<div class="img-box">
  <a class="tvb-link img-link" routerLink="/{{ product?.brandsSeoUrl ?? 'item' }}" [queryParams]="{ pdp: product?.id }">
    <img
      class="img"
      [defaultImage]="'assets/images/placeholder.png'"
      [errorImage]="'assets/images/placeholder.png'"
      [lazyLoad]="product?.imageUrl"
      [alt]="product?.name"
    />
  </a>
</div>

<div class="info">
  <!-- <tvb-badge
    label="We Love"
    backgroundColor="#EDE9E1"
    color="#000000"
    borderRadius="50px"
    class="we-love-badge"
    *ngIf="showWeLoveTag"
  ></tvb-badge> -->

  <br />

  <div class="brand">
    <a class="tvb-link" routerLink="/designer/{{ product?.brandName?.toLowerCase() }}">
      {{ product?.brandName }}
    </a>
  </div>

  <div class="name text-overflow-ellipsis" [title]="product?.name">
    <a class="tvb-link" routerLink="/{{ product?.brandsSeoUrl ?? 'item' }}" [queryParams]="{ pdp: product?.id }">
      {{ product?.name }}
    </a>
  </div>

  <br />

  <div class="price">
    <a class="tvb-link" routerLink="/{{ product?.brandsSeoUrl ?? 'item' }}" [queryParams]="{ pdp: product?.id }">
      <div [ngClass]="{ 'text-line-through': product?.isDiscount }">
        {{ product['regularPrice' + currencyCode] | currency: currencyCode }}
      </div>

      <div class="discount-price" *ngIf="product?.isDiscount">
        {{ product['discountedPrice' + currencyCode] | currency: currencyCode }}
      </div>
    </a>
  </div>
</div>
